// extracted by mini-css-extract-plugin
export default {"table":"ActivityTablePanel_table__h8ty1"};